import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateTenantStripeConnectedAccountMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type CreateTenantStripeConnectedAccountMutation = { __typename?: 'Mutation', createTenantStripeConnectedAccount: { __typename?: 'TenantStripeConnectPayload', stripeConnect?: { __typename?: 'TenantStripeConnectData', connectedAccountId?: string | null, onboardingComplete: boolean, taxSettingsStatus: Types.StripeTaxSettingsStatus, taxMissingFields: Array<string>, taxReadinessCheckedAt?: Types.TDateISO | null, isTaxReady: boolean, activeTaxRegistrationCount: number, country?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CreateTenantStripeAccountSessionMutationVariables = Types.Exact<{
  components: Array<Types.StripeConnectComponent> | Types.StripeConnectComponent;
}>;


export type CreateTenantStripeAccountSessionMutation = { __typename?: 'Mutation', createTenantStripeAccountSession: { __typename?: 'StripeAccountSessionPayload', clientSecret?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RefreshTenantStripeTaxReadinessMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type RefreshTenantStripeTaxReadinessMutation = { __typename?: 'Mutation', refreshTenantStripeTaxReadiness: { __typename?: 'TenantStripeConnectPayload', stripeConnect?: { __typename?: 'TenantStripeConnectData', connectedAccountId?: string | null, onboardingComplete: boolean, taxSettingsStatus: Types.StripeTaxSettingsStatus, taxMissingFields: Array<string>, taxReadinessCheckedAt?: Types.TDateISO | null, isTaxReady: boolean, activeTaxRegistrationCount: number, country?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CreateTenantStripeConnectedAccountDocument = new TypedDocumentString(`
    mutation CreateTenantStripeConnectedAccount {
  createTenantStripeConnectedAccount {
    stripeConnect {
      ...TenantStripeConnectSummary
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantStripeConnectSummary on TenantStripeConnectData {
  connectedAccountId
  onboardingComplete
  taxSettingsStatus
  taxMissingFields
  taxReadinessCheckedAt
  isTaxReady
  activeTaxRegistrationCount
  country
}`);
export const CreateTenantStripeAccountSessionDocument = new TypedDocumentString(`
    mutation CreateTenantStripeAccountSession($components: [StripeConnectComponent!]!) {
  createTenantStripeAccountSession(components: $components) {
    clientSecret
    errors {
      code
      message
    }
  }
}
    `);
export const RefreshTenantStripeTaxReadinessDocument = new TypedDocumentString(`
    mutation RefreshTenantStripeTaxReadiness {
  refreshTenantStripeTaxReadiness {
    stripeConnect {
      ...TenantStripeConnectSummary
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantStripeConnectSummary on TenantStripeConnectData {
  connectedAccountId
  onboardingComplete
  taxSettingsStatus
  taxMissingFields
  taxReadinessCheckedAt
  isTaxReady
  activeTaxRegistrationCount
  country
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateTenantStripeConnectedAccount: build.mutation<CreateTenantStripeConnectedAccountMutation, CreateTenantStripeConnectedAccountMutationVariables | void>({
      query: (variables) => ({ document: CreateTenantStripeConnectedAccountDocument, variables })
    }),
    CreateTenantStripeAccountSession: build.mutation<CreateTenantStripeAccountSessionMutation, CreateTenantStripeAccountSessionMutationVariables>({
      query: (variables) => ({ document: CreateTenantStripeAccountSessionDocument, variables })
    }),
    RefreshTenantStripeTaxReadiness: build.mutation<RefreshTenantStripeTaxReadinessMutation, RefreshTenantStripeTaxReadinessMutationVariables | void>({
      query: (variables) => ({ document: RefreshTenantStripeTaxReadinessDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateTenantStripeConnectedAccountMutation, useCreateTenantStripeAccountSessionMutation, useRefreshTenantStripeTaxReadinessMutation } = injectedRtkApi;
